import React from 'react';
import { Card } from './Card';

export function VideoRow({ imageURL }) {
  return (
    <Card
      imageURL={imageURL}
    />
  );
};